import { useLocation } from 'react-router-dom';

import { useUserData } from 'commons/contexts';
import { useClarity } from './useClarity';

export const Clarity = () => {
  const location = useLocation();
  const { user } = useUserData();

  useClarity(user, location);

  return null;
};
